export default [
  {
    id: "t-1001",
    groupId: "1",
    message:
      "QW23RTY Confirmed. Ksh1,500.00 received from John Doe 0712345678 on 17/01/2026 at 10:32 AM. New M-PESA balance is Ksh12,000.00.",
    purposeId: null
  },
  {
    id: "t-1002",
    groupId: "1",
    message:
      "SC45KLM Confirmed. Ksh750 received from Mary Wanjiku on 16/01/2026 at 7:18 PM. New M-PESA balance is Ksh11,250.00.",
    purposeId: null
  },
  {
    id: "t-2001",
    groupId: "2",
    message:
      "TRF2ABCD Confirmed. Ksh2,000 received from Peter Otieno 0798765432 on 15/01/2026 at 9:05 AM. New M-PESA balance is Ksh18,600.00.",
    purposeId: null
  }
];
